const e = Math.min, h = Math.max, a = Math.round, i = Math.floor, s = (t) => ({
  x: t,
  y: t
});
function m(t) {
  const {
    x: o,
    y: n,
    width: r,
    height: c
  } = t;
  return {
    width: r,
    height: c,
    top: n,
    left: o,
    right: o + r,
    bottom: n + c,
    x: o,
    y: n
  };
}
export {
  s as createCoords,
  i as floor,
  h as max,
  e as min,
  m as rectToClientRect,
  a as round
};
